/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostPreRegistrationsRequestPreRegistration } from './PostPreRegistrationsRequestPreRegistration';
import {
    PostPreRegistrationsRequestPreRegistrationFromJSON,
    PostPreRegistrationsRequestPreRegistrationFromJSONTyped,
    PostPreRegistrationsRequestPreRegistrationToJSON,
} from './PostPreRegistrationsRequestPreRegistration';

/**
 * 
 * @export
 * @interface PostPreRegistrationsRequest
 */
export interface PostPreRegistrationsRequest {
    /**
     * 
     * @type {PostPreRegistrationsRequestPreRegistration}
     * @memberof PostPreRegistrationsRequest
     */
    preRegistration: PostPreRegistrationsRequestPreRegistration;
}

/**
 * Check if a given object implements the PostPreRegistrationsRequest interface.
 */
export function instanceOfPostPreRegistrationsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "preRegistration" in value;

    return isInstance;
}

export function PostPreRegistrationsRequestFromJSON(json: any): PostPreRegistrationsRequest {
    return PostPreRegistrationsRequestFromJSONTyped(json, false);
}

export function PostPreRegistrationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPreRegistrationsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preRegistration': PostPreRegistrationsRequestPreRegistrationFromJSON(json['pre_registration']),
    };
}

export function PostPreRegistrationsRequestToJSON(value?: PostPreRegistrationsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pre_registration': PostPreRegistrationsRequestPreRegistrationToJSON(value.preRegistration),
    };
}

